/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";

export class FSProlongSpin implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public getAnimation(data:ParsedServerData):Timeline | null {
        const newTl = new TimelineLite();
        newTl.add(new TweenLite(this, 0, {}));
        return newTl;
    }

}